import { NgModule } from '@angular/core';
import { SubmitComponent } from './submit.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzButtonModule,
        NzFormModule
    ],
    declarations: [SubmitComponent],
    exports: [SubmitComponent]
})
export class SubmitModule { }
